/**
 * Canonical dash pattern stored on `MapFeatureMapStyle.lineDashArray` — same semantics as
 * [Mapbox GL `line-dasharray`](https://docs.mapbox.com/style-spec/reference/layers/#paint-line-line-dasharray):
 * alternating dash and gap lengths, each a **multiple of the line stroke width** (CSS px).
 *
 * Example: `[2, 1]` with `lineWidth: 4` → dash 8px, gap 4px after Leaflet conversion.
 */
export type LineDashPattern = readonly number[]

/**
 * Converts a canonical {@link LineDashPattern} to pixel lengths along the stroke for renderers
 * that use absolute units (Leaflet `L.Path` `dashArray` / Canvas `setLineDash`).
 */
export function lineDashPatternToPixelSegments(
  pattern: LineDashPattern,
  lineWidthPx: number
): number[] {
  const w = Math.max(0, Number(lineWidthPx)) || 0
  return pattern.map((n) => Number(n) * w)
}
